import script from "./TimerSuggestionBubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerSuggestionBubble.vue?vue&type=script&setup=true&lang=ts"

import "./TimerSuggestionBubble.vue?vue&type=style&index=0&id=2004ec62&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2004ec62"]])

export default __exports__